<template>
	<div class="header-wrap">
		<div class="header">
			<div class="header-l">
				<a href="/" :title="logoTitle"><img :alt="logoTitle" class="logo" src="@/assets/logo.png"/></a>
				<div id="nav-top">
					<navTop></navTop>
				</div>
			</div>
			<div class="header-r" v-if="isShowNav">
				<div class="search-top">
					<el-input placeholder="请输入" v-model="keyWords" @change="toSearch">
						<el-button @click="toSearch" slot="append" icon="el-icon-search"></el-button>
					</el-input>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import navTop from '@/components/product/navTop'
	export default {
		name: 'Header',
		props: {
			logoTitle: {
				type: String,
				default: '',
				keyWords: ''
			},
			isShowNav: {
				type: Boolean,
				default: true
			}
		},
		components: {
			navTop
		},
		data(){
			return {
				keyWords: ''
			}
		},
		methods: {
			toSearch(){
				this.$router.push({
					path: '/search',
					query: {
						keyWords: this.keyWords
					}
				})
				this.keyWords = ''
			}
		}
	}
</script>

<style scoped lang="less">
	.header-wrap{
		background: #fff;
		box-shadow: 0 2px 6px 0 rgba(0,0,0,0.08);
		position: fixed;
		left: 0;
		right: 0;
		top: 0;
		z-index: 99;
	}
	.header{
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 1180px;
		margin: 0 auto;
		box-sizing: border-box;
		position: relative;
		.header-l{
			display: flex;
			align-items: center;
		}
		.logo{
			width: 64px;
			height: 38px;
		}
		h1{
			color: #4A4A4A;
			font-size: 18px;
			font-weight: bold;
		}
		.search-top{
			/deep/ .el-input__inner {
				height: 30px;
				line-height: 30px;
			}
			/deep/ .el-input-group__append{
				padding: 0 10px
			}
			/deep/ .el-input__inner:focus{
				border-color: #DCDFE6
			}
		}
	}
</style>
